export default "__VITE_ASSET__8xvp0fkA__"